export default import.meta.ROLLDOWN_FILE_URL_BIF4svnEyutdhX6Emw8IGQ